import iconDark from 'assets/images/studio/data-source/databricks.dark.svg';
import iconLight from 'assets/images/studio/data-source/databricks.light.svg';
import cn from 'utils/cn';

interface DatabricksIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  style?: React.CSSProperties;
  variant?: 'light' | 'dark';
}

const DatabricksIcon = ({ variant = 'dark', ...rest }: DatabricksIconProps) => {
  return (
    <img
      {...rest}
      alt="databricks icon"
      data-testid={`databricks-icon-${variant}`}
      src={variant === 'light' ? iconLight : iconDark}
      className={cn('tw:h-[16px] tw:w-[16px]', rest?.className)}
    />
  );
};

export default DatabricksIcon;
